import { __awaiter, __generator } from "tslib";
var CLIENT_ID = 'officehome';
var UWP_CLIENT_ID = 'officehomeuwp';
var CONSUMER_CLIENT_ID = 'officehomemsa';
export function getHostAppId(capabilitiesPromise, identityPromise) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, isPwaInUwp, nativeSearchInHeaderEnabled, isMsa;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, capabilitiesPromise];
                case 1:
                    _a = _b.sent(), isPwaInUwp = _a.isPwaInUwp, nativeSearchInHeaderEnabled = _a.nativeSearchInHeaderEnabled;
                    return [4 /*yield*/, identityPromise];
                case 2:
                    isMsa = (_b.sent()).isMsa;
                    if (isMsa) {
                        return [2 /*return*/, CONSUMER_CLIENT_ID];
                    }
                    else {
                        if (isPwaInUwp && nativeSearchInHeaderEnabled) {
                            return [2 /*return*/, UWP_CLIENT_ID];
                        }
                        else {
                            return [2 /*return*/, CLIENT_ID];
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=getHostAppId.js.map